const SELECTORS = {
  toolbar: '[data-lestang-cart-selection]',
  line: '[data-lestang-cart-line-select]',
  all: '[data-lestang-cart-select-all]',
  status: '[data-lestang-cart-selection-status]',
  clear: '[data-lestang-cart-clear]',
};

const getComponent = (element) => element.closest('cart-items-component');
const getForm = (element) => element.closest('form.cart-form');

const getLines = (element) => {
  const form = getForm(element) || element.closest('.cart-items');
  return form ? [...form.querySelectorAll(SELECTORS.line)] : [];
};

const updateSelection = (element, overrideMessage = '') => {
  const component = getComponent(element);
  const toolbar = element.closest(SELECTORS.toolbar) || component?.querySelector(SELECTORS.toolbar);
  if (!toolbar) return;

  const lines = getLines(toolbar);
  const selected = lines.filter((line) => line.checked);
  const selectAll = toolbar.querySelector(SELECTORS.all);
  const status = toolbar.querySelector(SELECTORS.status);
  const checkout = component?.querySelector('[name="checkout"]');

  if (selectAll) {
    selectAll.checked = lines.length > 0 && selected.length === lines.length;
    selectAll.indeterminate = selected.length > 0 && selected.length < lines.length;
  }

  if (status) {
    const template = toolbar.dataset.selectedTemplate || '__COUNT__ / __TOTAL__';
    status.textContent = overrideMessage || template
      .replace('__COUNT__', String(selected.length))
      .replace('__TOTAL__', String(lines.length));
  }

  if (checkout instanceof HTMLButtonElement) checkout.disabled = selected.length === 0;
  component?.toggleAttribute('data-lestang-cart-partial', selected.length > 0 && selected.length < lines.length);
};

const checkoutSelected = (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.matches('form.cart-form')) return;
  const submitter = event.submitter;
  if (!(submitter instanceof HTMLElement) || submitter.getAttribute('name') !== 'checkout') return;

  const toolbar = event.target.querySelector(SELECTORS.toolbar);
  if (!toolbar) return;
  const lines = getLines(toolbar);
  const selected = lines.filter((line) => line.checked);
  if (selected.length === lines.length) return;

  event.preventDefault();
  if (!selected.length) {
    updateSelection(toolbar, toolbar.dataset.noneSelected || 'Select at least one item.');
    return;
  }

  if (selected.some((line) => line.dataset.sellingPlan || line.dataset.hasProperties === 'true')) {
    updateSelection(toolbar, toolbar.dataset.unsupported || 'This item must be checked out with the full cart.');
    return;
  }

  const quantities = new Map();
  selected.forEach((line) => {
    const variantId = line.dataset.variantId;
    const quantity = Math.max(1, Number(line.dataset.quantity) || 1);
    if (variantId) quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
  });

  const payload = [...quantities].map(([variantId, quantity]) => `${variantId}:${quantity}`).join(',');
  if (!payload) return;
  const root = window.Shopify?.routes?.root || '/';
  window.location.assign(`${root}cart/${payload}`);
};

document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLInputElement)) return;
  if (event.target.matches(SELECTORS.all)) {
    getLines(event.target).forEach((line) => { line.checked = event.target.checked; });
    updateSelection(event.target);
  } else if (event.target.matches(SELECTORS.line)) {
    updateSelection(event.target);
  }
});

document.addEventListener('click', (event) => {
  const label = event.target instanceof Element ? event.target.closest('.cart-items__selection label, .lestang-cart-selection__all') : null;
  if (!(label instanceof HTMLLabelElement)) return;
  const input = label.querySelector('input[type="checkbox"]');
  if (!(input instanceof HTMLInputElement) || event.target === input) return;
  event.preventDefault();
  input.checked = !input.checked;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest(SELECTORS.clear) : null;
  if (!(button instanceof HTMLButtonElement)) return;
  event.preventDefault();
  const toolbar = button.closest(SELECTORS.toolbar);
  if (!toolbar || button.disabled) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/clear.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Cart clear failed');
    const cart = await response.json();
    await window.LestangCartSync?.pushCart?.(cart);
    window.location.reload();
  } catch (_error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    updateSelection(toolbar, toolbar.dataset.clearError || 'Unable to clear cart.');
  }
});

document.addEventListener('submit', checkoutSelected, true);

document.querySelectorAll(SELECTORS.toolbar).forEach((toolbar) => updateSelection(toolbar));
